import adaptLegacyGradeType from './adaptLegacyGradeType';
import isArrayEmpty from './isArrayEmpty';

const getSelectedGradeType = ({ selectedAssignmentDetails }) => {
  if (isArrayEmpty(selectedAssignmentDetails)) {
    return null;
  }

  return adaptLegacyGradeType(selectedAssignmentDetails[0].gradeType);
};

export default getSelectedGradeType;
